export default {
  loading: 'Loading...',
  categories: {
    basic: 'Basic',
    object: 'Objects',
    symbol: 'Symbols',
    arrow: 'Arrows',
    flowchart: 'Flowchart',
    animal: 'Animals',
    game: 'Cards & Chess',
    dialog_balloon: 'Dialog balloons',
    electronics: 'Electronics',
    math: 'Mathematical',
    music: 'Music',
    misc: 'Miscellaneous',
    raphael_1: 'raphaeljs.com set 1',
    raphael_2: 'raphaeljs.com set 2'
  },
  buttons: [
    {
      title: 'Shape library'
    }
  ]
}
